import { render } from "./LayoutES.vue?vue&type=template&id=228d1965&scoped=true"
import script from "./LayoutES.vue?vue&type=script&lang=js"
export * from "./LayoutES.vue?vue&type=script&lang=js"

import "./LayoutES.vue?vue&type=style&index=0&id=228d1965&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-228d1965"]])

export default __exports__